export const scream = new Audio("/assets/scream.mp3");
